// extracted by mini-css-extract-plugin
export default {"melodyVideo":"cI-z","isFullWidth":"dI-z","landingPageVideo":"eI-z","play":"fI-z","iframeVideo":"gI-z","playHidden":"hI-z","fullwidth":"iI-z"};